var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMedium(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 16,
    viewBox: "0 0 29 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_81_986)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27 13.9001C26.6 13.5001 26 11.6001 26 8.0001C26 4.4001 26.6 2.4001 26.9 2.1001C27.3 2.5001 27.8 4.6001 27.8 8.0001C27.9 11.6001 27.3 13.5001 27 13.9001Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4992 14.5999C18.6992 14.5999 17.1992 11.5999 17.1992 7.9999C17.1992 5.4999 17.8992 3.1999 18.9992 2.0999C19.4992 1.5999 19.9992 1.3999 20.4992 1.3999C21.2992 1.3999 22.1992 2.0999 22.7992 3.1999C23.4992 4.4999 23.8992 6.1999 23.8992 7.9999C23.8992 11.5999 22.2992 14.5999 20.4992 14.5999Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.9 15C4.1 15 1 11.9 1 8C1 6.1 1.7 4.4 3 3C4.3 1.7 6.1 1 7.9 1C9.8 1 11.5 1.7 12.8 3.1C14.1 4.4 14.8 6.2 14.8 8.1C14.9 11.9 11.7 15 7.9 15Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_81_986"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.9,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.88b1df0cd4fba32a91140609053abfce.svg";
export { ForwardRef as ReactComponent };